import { createStore } from "vuex";

// Create a new store instance.
const store = createStore({
  state() {
    return {
      user : {
        username : 'ARB',
        password : 'ARB19901990',
      },
      localLogin : false,
      count: 0,
      carteRoutierUrl:
        "https://www.scribblemaps.com/maps/view/CARTE%20ROUTI%C3%88RE%20DU%20BURUNDI/S1D75XkPsh",
      carteChausse:
        "https://widgets.scribblemaps.com/sm/?d&z&l&gc&sc&mc&dfe&lat=-2.868022798&lng=29.595941591&vz=9&type=satellite&ti&width=1200&height=700&id=ETAT_ROUTES",
      carteChantier:
        "https://widgets.scribblemaps.com/sm/?d&z&l&gc&sc&mc&dfe&lat=-3.002841166&lng=29.902998282&vz=10&type=satellite&ti&width=1200&height=700&id=TRAVAUX",
      cartes: {
        carteRoutierUrl:
          "https://www.scribblemaps.com/maps/view/CARTE%20ROUTI%C3%88RE%20DU%20BURUNDI/S1D75XkPsh",
        carteChausse:
          "https://widgets.scribblemaps.com/sm/?d&z&l&gc&sc&mc&dfe&lat=-2.868022798&lng=29.595941591&vz=9&type=satellite&ti&width=1200&height=700&id=ETAT_ROUTES",
        carteChantier:
          "https://widgets.scribblemaps.com/sm/?d&z&l&gc&sc&mc&dfe&lat=-3.002841166&lng=29.902998282&vz=10&type=satellite&ti&width=1200&height=700&id=TRAVAUX",
      },
    };
  },
  mutations: {
   
  },
});

export default store;
